// extracted by mini-css-extract-plugin
export default {"group":"MenuGroup--group--d4cc58","groupCheckbox":"MenuGroup--groupCheckbox--566650"};